import { login, getInfo } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  admin: {},
  menus: [],
  permissions: []
}

const mutations = {
  SET_TOKEN(state, token) { state.token = token },
  SET_ADMIN(state, admin) { state.admin = admin },
  SET_MENUS(state, menus) { state.menus = menus },
  SET_PERMISSIONS(state, permissions) { state.permissions = permissions }
}

const actions = {
  login({ commit }, userInfo) {
    return login(userInfo).then(res => {
      commit('SET_TOKEN', res.data.token)
      commit('SET_ADMIN', res.data.admin || {})
      setToken(res.data.token)
    })
  },
  getInfo({ commit }) {
    return getInfo().then(res => {
      commit('SET_ADMIN', res.data.admin)
      commit('SET_MENUS', res.data.menus)
      commit('SET_PERMISSIONS', res.data.permissions)
    })
  },
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_ADMIN', {})
    removeToken()
  },
  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    removeToken()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    token: state => state.token,
    admin: state => state.admin,
    menus: state => state.menus
  }
}
